{
  "nl": {
    "customer": {
      "actions": {
        "addCompany": "Bedrijf toevoegen",
        "addCustomer": "Klant toevoegen",
        "addSecondaryContact": "Tweede contactpersoon toevoegen",
        "add_email_address": "Voeg email adres toe",
        "bulk_import": "Klanten importeren",
        "cancel": "Annuleer",
        "changeProfilePicture": "Verander profielfoto",
        "createNewCustomer": "Voeg nieuwe klant toe...",
        "goToCustomerProfile": "Ga naar de klantencontactpagina",
        "new": "Klant",
        "profilePictureFormat": "Afbeelding moet <strong>vierkant</strong> formaat zijn en min. <strong>300x300px</strong>",
        "removeCompany": "Verwijder bedrijfsgegevens",
        "removeCustomer": "Klant loskoppelen van unit",
        "removeSecondaryContact": "Verwijder tweede contactpersoon",
        "save": "Opslaan",
        "searchCustomer": "Zoek Klant",
        "submit": "Opslaan",
        "uploadProfilePicture": "Upload een Profielfoto"
      },
      "attributes": {
        "address": "Adres",
        "birth_date": "Geboortedatum",
        "categories": {
          "enduser": "Koper-Bewoner",
          "investor": "Investeerder"
        },
        "category": "Type Klant",
        "company_name": "Bedrijfsnaam",
        "company_vat": "BTW-nummer",
        "email_address": "E-mail",
        "email_address_secondary": "Secundair contact e-mailen",
        "email_notifications_interval": {
          "daily": "Een keer per dag (rond het middaguur)",
          "hourly": "Elk uur",
          "twice_daily": "Tweemaal per dag (middag/avond)",
          "weekly": "Een keer per week (maandagmiddag)"
        },
        "first_name": "Voornaam",
        "iban": "IBAN",
        "internal_note": "Interne Notitie",
        "language": "Taal",
        "last_name": "Achternaam",
        "phone_landline": "Vast nummer",
        "phone_mobile": "Mobiel nummer",
        "status": "Status"
      },
      "import": {
        "fill_customer_info": "Template invullen met klantinformatie",
        "fix_file_upload_customer": "Los de problemen op en upload het bestand opnieuw.</br>Bestaande klanten worden niet verwijderd, maar worden bijgewerkt als er iets is gewijzigd in het bestand voor die klant sinds de laatste upload."
      },
      "labels": {
        "customerAddedState": "<b>Nog niet uitgenodigd.</b> Er wordt een uitnodigingsmail verzonden zodra {name} toegang krijgt tot een toegewezen unit.",
        "customerAddedStateNoEmailAddress": "<b>Geen emailadres gekend.</b> Een emailadres is nodig om {name} toegang te geven tot een toegewezen unit.",
        "display": "Weergave",
        "hasAccessToUnit": "Heeft online toegang tot unit",
        "information": "Profiel Informatie",
        "noCustomersYet": "Nog geen klanten op het platform",
        "noEmailAddress": "Geen emailadres",
        "noProject": "Nog geen project toegewezen",
        "noUnits": "Nog geen units toegewezen",
        "notSharedWithCustomer": "Niet zichtbaar voor klant",
        "notificationDisclaimer": "Wanneer er iets nieuws beschikbaar is op het platform, ontvang je hiervan een melding. Als je deze meldingen nog niet op het platform hebt gelezen, worden ze gebundeld en per e-mail verzonden. Hieronder kan je meldingen over bepaalde onderwerpen uitschakelen en de frequentie van de e-mails verhogen/verlagen.",
        "onPlatform": "Op Platform",
        "otherSettings": "Andere",
        "password": "Wachtwoord",
        "primaryContact": "Jouw gegevens",
        "project": "Project",
        "secondaryContact": "Tweede contactpersoon",
        "sharedWithCustomer": "Zichtbaar voor de klant",
        "sorting": "Sorteren",
        "units": "Units",
        "viaEmail": "Via E-mail"
      },
      "messages": {
        "integrationUpdateInformation": "Gelieve ons te contacteren indien u bepaalde informatie wenst aan te passen.",
        "userlessProfileNotice": "Dit profiel heeft geen e-mailadres gekoppeld. Bepaalde instellingen kunnen niet worden gewijzigd."
      },
      "toasts": {
        "birthday": "Gelukkige verjaardag, {first_name}!",
        "create": "Klant aangemaakt",
        "delete": "Klant verwijderd",
        "update": "Klant gewijzigd",
        "upload": "Alle klanten succesvol geïmporteerd"
      },
      "validation": {
        "needFirstName": "Voornaam vereist",
        "needFirstNameSecondary": "Voornaam tweede contactpersoon vereist",
        "needLastName": "Achternaam vereist",
        "needLastNameSecondary": "Achternaam tweede contactpersoon vereist"
      }
    }
  }
}
